import { CARD_BRANDS } from "../constants";

export const BT_CARD_TYPES = Object.freeze({
	Debit: "Debit",
	Credit: "Credit"
});

export const BT_CARD_BRANDS = Object.freeze({
	mastercard: CARD_BRANDS.MASTERCARD,
	visa: CARD_BRANDS.VISA,
	"american-express": CARD_BRANDS.AMERICAN_EXPRESS,
	"diners-club": CARD_BRANDS.DINERS_CLUB,
	discover: CARD_BRANDS.DISCOVER,
	jcb: CARD_BRANDS.JCB,
	unionpay: CARD_BRANDS.UNION_PAY,
	maestro: CARD_BRANDS.MAESTRO,
	amex: CARD_BRANDS.AMERICAN_EXPRESS
});

export const CARD_INFO_SCHEMA = Object.freeze({
	required: ["cardBrand", "cardType"],
	properties: {
		cardBrand: {
			type: "string",
			enum: Object.keys(BT_CARD_BRANDS)
		},
		cardType: {
			type: "string",
			enum: Object.values(BT_CARD_TYPES)
		}
	}
});
